import * as http from '~/utils/apis';

const userInventoryApi = {
    getAll: async (params) => {
        const res = await http.get(`cms-api/user-inventory`, params);
        if (res) {
            const rows = res.data.data;
            for (let row of rows) {
                for (let inventory of row.user_inventories) {
                    if (row[inventory.item] == undefined) row[inventory.item] = '';
                    switch (inventory.item) {
                        case 'hero':
                            row[inventory.item] += `${inventory.name}, `;
                            break;
                        case 'hero_token':
                            row[inventory.item] += `${inventory.name}:${inventory.quantity}, `;
                            break;
                        default:
                            row[inventory.item] = inventory.quantity;
                    }
                }
            }
            const totalRows = res.data.total;
            return { rows, totalRows };
        }
    },
};

export default userInventoryApi;